import React, { CSSProperties } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
  TextareaProps,
} from '@chakra-ui/react';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface TextAreaInputFormProps extends TextareaProps {
  name: string | undefined | any;
  label: string | undefined;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  labelStyles?: CSSProperties;
  infoButton?: JSX.Element;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const TextAreaInputForm = ({
  name,
  label,
  labelStyles,
  isRequired = false,
  register,
  errors,
  ...rest
}: TextAreaInputFormProps) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]} mb={5}>
      <FormLabel style={labelStyles} fontWeight="bold" mb={1} mr={3} htmlFor={name}>
        {label}
      </FormLabel>
      <Textarea
        id={name}
        boxShadow="0px 2px 4px #00000050"
        borderRadius="5px"
        background="theme.light.bodyInput"
        minH="250px"
        _disabled={{ color: '#fffff' }}
        {...register(name)}
        {...rest}
      />
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
